import {routes} from "../Router/routes";


export const configureItem = [

    // general settings
    {
        title: "General Settings",
        settingsList: [


            // {
            //     name: "Circle Offices",
            //     icon: "/images/circleOffice.png",
            //     navigateTo: ""
            // },
            // {
            //     name: "Region",
            //     icon: "/images/region.png",
            //     navigateTo: ""
            // },
            {
                name: "Requisition Types",
                icon: "/images/requisitionType.png",
                navigateTo: routes.settingsConfigureRequisitionTypes
            }
        ]
    },

    // employee settings
    {
        title: "Employee Settings",
        settingsList: [
            {
                // id: crypto.randomUUID(),
                name: "Departments",
                icon: "/images/department.png",
                navigateTo: routes.settingsConfigureDepartment
            },
            {
                name: "Department Types",
                icon: "/images/departmentType.png",
                navigateTo: routes.settingsConfigureDepartmentTypes

            },
            {
                name: "Payroll Types",
                icon: "/images/payrollType.png",
                navigateTo: routes.settingsConfigurePayrollTypes
            },
            {
                name: "Blood Group",
                icon: "/images/bloodGroup.png",
                navigateTo: routes.settingsConfigureBloodGroups
            },
            {
                // id: crypto.randomUUID(),
                name: "Document Types",
                icon: "/images/documentType.png",
                navigateTo: routes.settingsConfigureDocumentTypes
            },
            {
                name: "Designation Types",
                icon: "/images/designationType.png",
                navigateTo: routes.settingsConfigureDesignationTypes
            },
            // {
            //     name: "Payroll Type",
            //
            // }

        ]
    },

    //Administration settings
    {
        title: "Administration Settings",
        settingsList: [
            {
                name: "Role & Permission",
                icon: "/images/rolesAndPermission.png",
                navigateTo: routes.settingsConfigureManageRoles
            },
            // {
            //     name: "User Type",
            //     icon: "/images/userType.png",
            //     navigateTo: ""
            // }
        ]
    },

    //Approval authority settings
    // {
    //     title: "Approval Authority Settings",
    //     settingsList: [
    //         {
    //             name: "Vehicle Requisition",
    //             icon: "/images/vehicleRequisition.png",
    //             navigateTo: ""
    //         },
    //         {
    //             name: "Vehicle Re-fueling",
    //             icon: "/images/vehicleRefuel.png",
    //             navigateTo: ""
    //         },
    //         {
    //             name: "Vehicle Maintenance",
    //             icon: "/images/vehicleMaintenance.png",
    //             navigateTo: ""
    //         },
    //         {
    //             name: "Pickup and Drop",
    //             icon: "/images/vehiclePickupAndDrop.png",
    //             navigateTo: ""
    //         }
    //     ]
    // },

    //  Refueling settings
    {
        title: "Refueling Settings",
        settingsList: [
            {
                name: "Fuel Types",
                icon: "/images/fuelType.png",
                navigateTo: routes.settingsConfigureFuelTypes
            },
            {
                name: "Fuel Station",
                icon: "/images/fuelStation.png",
                navigateTo: routes.settingsConfigureFuelStation
            }
        ]
    },

    // vehicle settings
    {
        title: "Vehicle Settings",
        settingsList: [
            {
                name: "Vehicle Types",
                icon: "/images/vehicleType.png",
                navigateTo: routes.settingsConfigureVehicleTypes
            },
            {
                name: "Vehicle Brands",
                icon: "/images/vehicleBrand.png",
                navigateTo: routes.settingsConfigureVehicleBrands
            },
            {
                name: "Vehicle Device Vendor",
                icon: "/images/vehicleDeviceVendor.png",
                navigateTo: routes.settingsConfigureVehicleDeviceVendor
            },
            {
                name: "Vehicle Tracking Devices",
                icon: "/images/trackingDevice.png",
                navigateTo: routes.settingsConfigureVehicleTrackingDevices
            },
            {
                name: "Device Mapping",
                icon: "/images/deviceMapping.png",
                navigateTo: routes.settingsConfigureDeviceMapping
            }
        ]
    },

    //  parking settings
    {
        title: "Parking Settings",
        settingsList: [
            {
                name: "Parking Slot Types",
                icon: "/images/parkingSlotType.png",
                navigateTo: routes.settingsConfigureVehicleParkingSlotTypes
            },
            {
                name: "Parking Campuses",
                icon: "/images/parkingCampus.png",
                navigateTo: routes.settingsConfigureVehicleParkingCampuses
            }

        ]
    },


    //     Finance settings
    //     {
    //         title: "Finance Settings",
    //         settingsList: [
    //             {
    //                 name: "Manage Bank",
    //                 icon: "",
    //                 navigateTo: ""
    //             },
    //             {
    //                 name: "Payment Method",
    //                 icon: "",
    //                 navigateTo: ""
    //             },
    //             {
    //                 name: "Loan Type",
    //                 icon: "",
    //                 navigateTo: ""
    //             }
    //         ]
    //     }
]